"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog from "@/components/dialog/UiDialog.vue";
import { updateAPI } from "@/api/versionCheck/update.api";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import ProgressComponent from "@/components/progress/Progress.vue";
import BrowserVersionConfig from "@/app_views/settings/settingconfig/BrowserVersionConfig.vue";
let VersionConfig = class extends Vue {
  constructor() {
    super(...arguments);
    //   当前客户端版本号
    this.version = "";
    //   检查更新状态
    this.updateStatus = "check";
    //   显示的更新内容
    this.upgrade = null;
    //   更新按钮loading
    this.update_loading = false;
    //   建立websocket监听
    this.webSocketViewService = WebsocketViewService;
    //   安装提示窗弹出的同步锁
    this.showLock = false;
    //   下载提示弹窗的同步锁
    this.showUpdate = false;
    //   下载提示弹窗对象
    this.notify = null;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.checkVersion();
      this.webSocketViewService._ipcEvent.on(
        "event:update.need.install",
        (data) => __async(this, null, function* () {
          this.installStart();
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:pageEvent.start.install",
        (data) => __async(this, null, function* () {
          this.updateStart();
        })
      );
    });
  }
  //   获取当前客户端版本
  checkVersion() {
    return __async(this, null, function* () {
      let clientVersion = yield updateAPI.getClientVersion();
      this.version = clientVersion.version;
    });
  }
  //   更新客户端
  updateClient() {
    return __async(this, null, function* () {
      try {
        this.update_loading = true;
        const req = {
          model: "version.update",
          url: this.upgrade.url
        };
        yield updateAPI.createUpdateTask(req);
        try {
          yield API.head(`api://base.local/update/tasks`);
          this.installStart();
        } catch (error) {
          yield API.post(`api://base.local/websockets/view`, {
            model: "pageEvent.start.install"
          });
        }
        this.closeUpdate();
      } catch (error) {
        console.log(error);
      }
    });
  }
  updateStart() {
    if (this.showUpdate === true) {
      return;
    }
    this.showUpdate = true;
    const h = this.$createElement;
    this.notify = this.$notify({
      title: this.$t("homepage.downloading"),
      dangerouslyUseHTMLString: true,
      duration: 0,
      message: h(ProgressComponent)
    });
  }
  installStart() {
    if (this.showLock === true) {
      return;
    }
    this.showLock = true;
    if (sessionStorage.getItem("install_message_notify")) {
      return;
    }
    const h = this.$createElement;
    const notify = this.$notify({
      title: this.$t("homepage.installing"),
      duration: 0,
      message: h("div", {}, [
        h(
          "el-button",
          {
            props: { type: "text" },
            on: {
              click: this.startInstall
            }
          },
          this.$t("homepage.start_install")
        ),
        h(
          "el-button",
          {
            props: { type: "text" },
            style: "color:#c0c4d4",
            on: {
              click: () => {
                this.installNextTime();
                notify.close();
              }
            }
          },
          this.$t("homepage.next_time")
        )
      ]),
      onClose: () => {
        this.showLock = false;
      }
    });
  }
  installNextTime() {
    return __async(this, null, function* () {
      sessionStorage.setItem("install_message_notify", "show");
      yield API.put(`api://base.local/storages/session/updateInstall`, {
        message: "no.need.install",
        model: "no.need.install"
      });
    });
  }
  startInstall() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/update/install`);
      } catch (error) {
        console.log(error);
      }
    });
  }
  closeUpdate() {
    this._update_dialog.hide();
  }
  checkUpdate() {
    return __async(this, null, function* () {
      try {
        this.updateStatus = "check";
        let update_message = yield API.get(`api://base.update/v1/client/updates`);
        if (update_message.data.update || update_message.data.force) {
          this.updateStatus = "needUpdate";
          this.upgrade = update_message.data;
        }
        if (!update_message.data.update && !update_message.data.force) {
          this.updateStatus = "noneedUpdate";
        }
        this._update_dialog.show();
      } catch (error) {
        this.updateStatus = "noneedUpdate";
        this._update_dialog.show();
      }
    });
  }
  beforeDestroy() {
    this.webSocketViewService._ipcEvent.removeAllListeners();
  }
};
__decorateClass([
  Ref("update-dialog")
], VersionConfig.prototype, "_update_dialog", 2);
VersionConfig = __decorateClass([
  Component({
    components: { UiDialog, ProgressComponent, BrowserVersionConfig }
  })
], VersionConfig);
export {
  VersionConfig as default
};
